import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UniAccomGuard } from '../guards/uni-accom.guard';
import { AboutComponent } from './components/about/about.component';
import { AppTermsComponent } from './components/app-terms/app-terms.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { MarketingPreferencesComponent } from './components/marketing-preferences/marketing-preferences.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ProtectAndSaveProductComponentComponent } from './components/protect-and-save-product-component/protect-and-save-product-component.component';
import { ProtectAndSaveComponent } from './components/protect-and-save/protect-and-save.component';
import { ReferAFriendComponent } from './components/refer-a-friend/refer-a-friend.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { UpdateInsuranceComponent } from './components/update-insurance/update-insurance.component';
import { UpdateComponent } from './components/update/update.component';
import { ViewFaqComponent } from './components/view-faq/view-faq.component';
import { WellbeingComponent } from './components/wellbeing/wellbeing.component';
import { YourInsuranceComponent } from './components/your-insurance/your-insurance.component';
import { PartnerPageComponent } from './components/partner-page/partner-page.component';
import { StudentLifeComponent } from './components/student-life/student-life.component';
import { TopOffersPageComponent } from './components/top-offers/top-offers.component';
import { StudentLifeArticleComponent } from './components/student-life-article/student-life-article.component';
import { WellbeingArticleComponent } from './components/wellbeing-article/wellbeing-article.component';
import { InternationalStudentPageComponent } from './components/international-students/international-student-page.component';
import { MakeAClaimFormComponent } from './components/make-a-claim-form/make-a-claim-form.component';
import { InternationalStudentContactUsComponent } from './components/international-student-contact-us/international-student-contact-us.component';
import { PolicySummaryComponent } from './components/policy-summary/policy-summary.component';
import { JobsAndCareersComponent } from './components/jobs-and-careers/jobs-and-careers.component';
import { CheckAuthGuard } from '../guards/check-auth.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile',
    component: ProfileComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/howden-for-students',
    component: AboutComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/terms-and-conditions',
    component: TermsAndConditionsComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/faqs',
    component: FaqsComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/faqs/:faqUID',
    component: ViewFaqComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/update',
    component: UpdateComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/marketing-preferences',
    component: MarketingPreferencesComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/privacy-notice',
    component: PrivacyPolicyComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-profile/app-terms-of-use',
    component: AppTermsComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-insurance/update',
    component: UpdateInsuranceComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'my-insurance',
    component: YourInsuranceComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'protect-and-save',
    component: ProtectAndSaveComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'protect-and-save/:productUID',
    component: ProtectAndSaveProductComponentComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'refer-a-friend',
    component: ReferAFriendComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'wellbeing',
    component: WellbeingComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'wellbeing/:articleUid',
    component: WellbeingArticleComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'top-offers',
    component: TopOffersPageComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'partner',
    component: PartnerPageComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'student-life',
    component: StudentLifeComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'student-life/:articleUid',
    component: StudentLifeArticleComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'international-student',
    component: InternationalStudentPageComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'international-student/make-a-claim',
    component: MakeAClaimFormComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'international-student/contact-us',
    component: InternationalStudentContactUsComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'international-student/policy-summary',
    component: PolicySummaryComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  {
    path: 'jobs-and-careers',
    component: JobsAndCareersComponent,
    canActivate: [UniAccomGuard, CheckAuthGuard],
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
